export default "__VITE_ASSET__Dy88lpq6__"